import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const AdminGuard = ({ children }) => {
  const location = useLocation();
  
  // Check if admin is authenticated
  const isAuthorized = localStorage.getItem('imatrix_admin_logged') === 'true';

  if (!isAuthorized) {
    // Redirect to login page, preserving the requested route location
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AdminGuard;
